import React, { useState, useContext, useEffect } from "react";
import BasicContext from '../BasicContext';
import { Picker, InputItem, List } from 'antd-mobile';

export function CustomerFilter(props) {

  const { value, onChange, rangerName, options, ...other } = props;

  const context = useContext(BasicContext);
  const customers = options || context.customers || [];

  const rangerItem = (item) => {
    if (item.CompanyId) {
      return rangerName ? rangerName(item) : `${item.UserEmail || ''}(${item.CompanyId || ''})-${item.OrganizationName || item.AccountName}(${item.OrganizationId || item.AccountId})`
    }

    return rangerName ? rangerName(item) : `${item.OrganizationName || item.AccountName}-${item.AccountAlias}-${item.OrganizationId || item.AccountId}`;
  }

  const getOptions = (customers) => {
    let options = [];
    if (customers && customers.length > 0) {
      //格式化并去重
      customers.forEach(item => {
        if (!options.find(o => o.value === item.OrganizationId || o.value === item.AccountId)) {
          options.push({ label: rangerItem(item), value: item.OrganizationId || item.AccountId })
        }
      });
    }
    return options
  }

  const [accountOptions, setAccountOptions] = useState([]);

  const onSearchChange = (v) => {
    const filterAccount = customers.filter(item => (item.CompanyName + item.CompanyId + item.UserEmail + item.OrganizationName + item.OrganizationId + item.AccountName + item.AccountId).indexOf(v) >= 0);
    const options = getOptions(filterAccount);
    setAccountOptions(options);
  }

  useEffect(() => {
    onSearchChange('');
  }, [customers]);

  return <Picker
    title={<InputItem
      placeholder="项目ID、email或项目名称搜索"
      className="picker-search-input"
      style={{ width: "100%" }}
      clear={true}
      onChange={onSearchChange}
    />}
    itemStyle={{ fontSize: 12 }}
    data={accountOptions}
    value={value}
    onChange={v => onChange(v)}
    cols={1}
    {...other}
  >
    <List.Item arrow="horizontal">项目ID</List.Item>
  </Picker>
}
